
import React, { useState } from 'react';
import Layout from '@/components/layout/Layout';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import SupportHero from '@/components/support/SupportHero';
import SupportSearch from '@/components/support/SupportSearch';
import FAQSection from '@/components/support/FAQSection';
import ContactSection from '@/components/support/ContactSection';
import GuidesSection from '@/components/support/GuidesSection';
import LiveSupportSection from '@/components/support/LiveSupportSection';
import AdditionalResources from '@/components/support/AdditionalResources';
import BusinessSupport from '@/components/support/BusinessSupport';
import FeedbackSection from '@/components/support/FeedbackSection';
import TranslatedText from '@/TranslatedText';

const Support = () => {
  const [searchQuery, setSearchQuery] = useState('');
  return <Layout>
      <div className="max-w-7xl mx-auto px-4 py-12">
        {/* Hero Section */}
        <SupportHero />

        {/* Search Bar */}
        <SupportSearch searchQuery={searchQuery} setSearchQuery={setSearchQuery} />

        {/* Support Options Tabs */}
        <Tabs defaultValue="faq" className="mb-16">
          <TabsList className="grid w-full grid-cols-4">
            <TabsTrigger value="faq"><TranslatedText text="FAQs" /></TabsTrigger>
            <TabsTrigger value="contact"><TranslatedText text="Contact Us" /></TabsTrigger>
            <TabsTrigger value="guides"><TranslatedText text="Self-help Guides" /></TabsTrigger>
            <TabsTrigger value="chatbot"><TranslatedText text="Live Support" /></TabsTrigger>
          </TabsList>
          
          {/* FAQ Tab */}
          <TabsContent value="faq" className="mt-6">
            <FAQSection />
          </TabsContent>
          
          {/* Contact Us Tab */}
          <TabsContent value="contact" className="mt-6">
            <ContactSection />
          </TabsContent>
          
          {/* Self-help Guides Tab */}
          <TabsContent value="guides" className="mt-6">
            <GuidesSection />
          </TabsContent>
          
          {/* Live Support Tab */}
          <TabsContent value="chatbot" className="mt-6">
            <LiveSupportSection />
          </TabsContent>
        </Tabs>
        
        {/* Support Resources */}
        <AdditionalResources />
        
        {/* Business Support */}
        <BusinessSupport />
        
        {/* Feedback Section */}
        <FeedbackSection />
      </div>
    </Layout>;
};
export default Support;
